function replaceConfigVariables({ html, publicConfig }) {
  let result = html

  for (const [key, value] of Object.entries(publicConfig)) {
    const spanRegex = new RegExp(`<span\\s+class=["']variable-tag["']>\\s*\\{\\{${key}\\}\\}\\s*<\\/span>`, 'g')

    result = result.replace(spanRegex, value)

    const variableRegex = new RegExp(`\\{\\{${key}\\}\\}`, 'g')
    result = result.replace(variableRegex, value)
  }

  return result
}

export { replaceConfigVariables }
